/**
 * 작업환경측정 대상물질(WOR_BASIC_02) 컬럼 정의
 * - GetWorBasic02R1: 대상물질-공정 매트릭스 (동적 피벗)
 * - 고정: 대상물질(korNm), 노출 허용 기준, 비고
 * - 공정: gongjongColumns(GetWorBasic02R1 응답 Columns) 기준 동적 컬럼
 */

import { CreateColumn } from '../../../../Services/agGrid/createColumn';

/**
 * 공정 셀 포맷 (O/빈값 표시 - 화면 규격에 맞춰 대문자 O)
 */
const processValueFormatter = (params) => {
  const v = params.value;
  if (v === true || v === 'Y' || v === '1' || v === 'O' || v === 'o') return 'O';
  return '';
};

/**
 * 공정 1건으로 컬럼 정의 생성 (Field = 그리드 필드명, HeaderName = 헤더 텍스트)
 * @param {{ Field?: string, HeaderName?: string, field?: string, headerName?: string }} col - GetWorBasic02R1 Columns 항목
 */
const buildProcessColumn = (col) => {
  const field = col.Field ?? col.field ?? '';
  const headerName = col.HeaderName ?? col.headerName ?? field;
  return CreateColumn(field, headerName, 'center', 120, false, false, false, 'text', {
    minWidth: 100,
    valueFormatter: processValueFormatter,
    wrapHeaderText: true,
    headerClass: 'ag-header-cell-wrap',
  });
};

/**
 * 작업환경측정 대상물질 탭 그리드 컬럼 정의
 * @param {object} props - gongjongColumns: GetWorBasic02R1 응답의 Columns 배열
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  const gongjongColumns = props.gongjongColumns ?? [];
  const processChildren = gongjongColumns.map(buildProcessColumn);

  const processGroup =
    processChildren.length > 0
      ? {
          headerName: '공정',
          headerClass: 'header-align-center',
          children: processChildren,
        }
      : null;

  const columns = [
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      checkboxProps: {
        DeleteNewRow: props.DeleteNewRow1,
        RestoreRow: props.RestoreRow1,
        gridRef: props.gridRef1,
        rowData: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef1,
        lastCheckedIndexRef: props.lastCheckedIndexRef1,
        handleRowSelection: props.handleRowSelection1,
      },
      maxWidth: 100,
      pinned: 'left',
    }),
    CreateColumn('korNm', '대상물질', 'left', 250, false, false, false, 'text', {
      minWidth: 250,
      pinned: 'left',
    }),
    CreateColumn(
      'exposureLimit',
      '노출 허용 기준',
      'center',
      200,
      false,
      false,
      false,
      'text',
      {
        minWidth: 200,
        valueGetter: (params) => {
          const d = params.data;
          if (!d) return '';
          return d.exposureLimit ?? d.twaVal ?? d.stelVal ?? '';
        },
      }
    ),
  ];

  if (processGroup) columns.push(processGroup);

  columns.push(
    CreateColumn('remark', '비고', 'left', 150, true, false, false, 'text', {
      minWidth: 150,
    })
  );

  return columns;
};

const columnDefs = { getColumnDefs1 };
export default columnDefs;
